import jsKit from './jsKit';

const handleOAuthResponse = (response, reload = false) => {
  if (response?.status === 200) {
    if (reload || response.redirect === 'reload') {
      window.location.reload();
    } else if (response.redirect) {
      window.location.assign(response.redirect);
    }
    return;
  }

  jsKit.showNotificationsPanel(response?.message || 'Nie udało się zalogować przez Google.', 'error');
};

const authenticateWithGoogle = async (jwtToken) => {
  const action = jwtToken?.state || 'signin';
  const response = await jsKit.requestUrl(
    `/client/oauth/${action}`,
    'urlencoded',
    'POST',
    new URLSearchParams({ token: jwtToken?.credential || '', provider: 'google' }),
  );

  handleOAuthResponse(response);
};

const connectGoogleAccount = async (jwtToken) => {
  const response = await jsKit.requestUrl(
    '/client/oauth/use',
    'urlencoded',
    'POST',
    new URLSearchParams({ token: jwtToken?.credential || '', provider: 'google' }),
  );

  handleOAuthResponse(response, true);
};

export const initOAuth = () => {
  // Google Identity Services invokes these callbacks by their global names.
  globalThis.authWithGoogle = authenticateWithGoogle;
  globalThis.useWithGoogle = connectGoogleAccount;
};
